import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import ProfileToolbar from 'components/account/ProfileToolbar';
import ProfileGeneralInformationEditForm from 'components/account/ProfileGeneralInformationEditForm';
import ProfileAccessSetup from 'components/account/ProfileAccessSetup';

import { fetchUser } from 'redux/modules/users';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class Profile extends Component {
  componentDidMount() {
    const { account, actions } = this.props;
    actions.fetchUser({
      ID: account.ID,
      triggerLoading: true,
    });
  }

  render() {
    const { user, history, loading } = this.props;
    return (
      <Layout variant="account-profile">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Profile
          </title>
        </Helmet>
        <ProfileToolbar />
        {(loading > 0 || !user) ? (
          <Progress />
        ) : (
          <Fragment>
            <ProfileGeneralInformationEditForm
              form={`profileGeneralInformationEdit-${user.ID}`}
              initialValues={{
                ID: user.ID,
                'First Name': user['First Name'],
                'Last Name': user['Last Name'],
                Email: user.Email,
                'Mobile Phone': user['Mobile Phone'],
                Gender: user.Gender,
                Title: user.Title,
                ...(user.Image['File Name'] && user.Image['File Url']) ?
                  { Image: {
                    name: user.Image['File Name'],
                    preview: `${user.Image['File Url']}${user.Image['File Name']}`,
                  } } : {},
              }}
              onSubmitSuccess={() => {
                history.goBack();
              }}
            />
            <ProfileAccessSetup {...user} />
          </Fragment>
        )}
      </Layout>
    );
  }
}

Profile.propTypes = {
  user: PropTypes.shape({
    ID: PropTypes.number,
  }),
  loading: PropTypes.number.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    fetchUser: PropTypes.func.isRequired,
  }).isRequired,
};

Profile.defaultProps = {
  user: null,
};

const mapStateToProps = (store) => {
  const users = store.users.data;
  return {
    user: users.length > 0
      ? users.find(user => user.ID === store.account.ID)
      : null,
    account: store.account,
    loading: store.users.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchUser }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/pages/account/Profile.js